import { map as mapCapped } from 'lodash/fp';
import React from 'react';
import { Breadcrumbs, Typography, Link } from '@mui/material';

const map = mapCapped.convert({ cap: false });

const IFIBreadcrumbs = (props) => {
  const { breadcrumbs } = props;
  return (
    <Breadcrumbs aria-label="breadcrumb">
      {map(
        ({ href, name }, index) =>
          href ? (
            <Link underline="hover" color="inherit" href={href} key={index}>
              {name}
            </Link>
          ) : (
            <Typography color="text.primary" key={index}>
              {name}
            </Typography>
          ),
        breadcrumbs,
      )}
    </Breadcrumbs>
  );
};
export { IFIBreadcrumbs };
